module.exports = __webpack_public_path__ + "img/VPBANK.83eaadf2.svg";